// ============================================
// TTS 상태 관리 (ES6)
// ============================================

// TTS 상태
let ttsState = {
  enabled: false,           // TTS 활성화 여부
  isPlaying: false,         // 현재 재생 중
  currentVoiceId: null,     // 현재 음성 프리셋 ID
  processedLength: 0        // 이미 처리한 텍스트 길이
};

// 현재 진행 중인 태그 블록 (완료되지 않은 블록)
let pendingBlock = { type: null, text: '', emotion: null };

// ============================================
// Getters
// ============================================

export function getTtsEnabled() {
  return ttsState.enabled;
}

export function getIsPlaying() {
  return ttsState.isPlaying;
}

export function getCurrentVoiceId() {
  return ttsState.currentVoiceId;
}

export function getProcessedLength() {
  return ttsState.processedLength;
}

export function getPendingBlock() {
  return pendingBlock;
}

// ============================================
// Setters
// ============================================

export function setTtsEnabled(value) {
  ttsState.enabled = value;
  // 세션 스토리지에 저장
  try {
    sessionStorage.setItem('ttsEnabled', value ? 'true' : 'false');
  } catch (e) {
    // 무시
  }
}

export function setIsPlaying(value) {
  ttsState.isPlaying = value;
}

export function setCurrentVoiceId(voiceId) {
  ttsState.currentVoiceId = voiceId;
}

export function setProcessedLength(length) {
  ttsState.processedLength = length;
}

export function setPendingBlock(block) {
  pendingBlock = block;
}

export function clearPendingBlock() {
  pendingBlock = { type: null, text: '', emotion: null };
}

// ============================================
// 상태 초기화/리셋
// ============================================

export function resetTtsState() {
  ttsState.isPlaying = false;
  ttsState.processedLength = 0;
  pendingBlock = { type: null, text: '', emotion: null };
}

export function initTtsState() {
  // 세션 스토리지에서 복원 (기본값: true)
  try {
    const saved = sessionStorage.getItem('ttsEnabled');
    if (saved !== null) {
      ttsState.enabled = saved === 'true';
    } else {
      // 저장된 값 없으면 기본 활성화
      ttsState.enabled = true;
    }
  } catch (e) {
    // 오류 시 기본 활성화
    ttsState.enabled = true;
  }
}

// 초기화
initTtsState();
